Bingo.DropdownFilter = {};

Bingo.DropdownFilter.init = () => {
    $('.js__filter-select').selectize({
        allowEmptyOption: true,
        copyClassesToDropdown: false,
        create: false,
        render: {
            item: function item(_item6) {
                return `<span>${_item6.text}</span>`;
            },
            option: function option(item) {
                return `<div class="A-selectDropdown__option">${item.text}</div>`;
            },
        },
        onInitialize: function onInitialize() {
            this.$control_input[0].type = 'text';
            this.$control_input.addClass('A-select__input no-live-validation');
            this.$control_input.attr('data-lfv-dont-remove-group-error-label', 'true');
            this.$dropdown.closest('.selectize-control').find('.items').addClass('A-textField__formElement').addClass('js-textField__formElement');
            this.$dropdown.addClass('A-selectDropdown');
            this.$dropdown_content.addClass('A-selectDropdown__options');

            this.$control_input.attr('readonly', 'true');
        },
        onChange: function onChange() {
            // if dropdown filter shouldn't send a server request stop event
            if (this.$input.data('filter-send-request') === 'false') {
                return false;
            }
            const filterUrl = this.$input.data('filter-url');
            const data = {};
            // group selected values for each dropdown filter on page
            $('select.js__filter-select').each(function () {
                const selectedValue = $(this).children('option:selected').val();
                const parameterName = $(this).data('filter-url-parameter-name');
                if (typeof selectedValue !== 'undefined' && selectedValue !== '' && typeof parameterName !== 'undefined') {
                    data[parameterName] = selectedValue;
                }
            });
            // add selected value of search autocomplete to server request parameters
            const selectedItem = $('.js-searchAutocomplete--projects').data('selected-item');
            if (typeof selectedItem !== 'undefined' && selectedItem !== null && typeof selectedItem.results !== 'undefined' && selectedItem.results !== '') {
                data.project = selectedItem.results;
            }
            $.nette.ajax({
                type: 'GET',
                url: filterUrl,
                data,
            });
            return true;
        },
        onDropdownClose: function onDropdownClose() {
            const value = this.getValue();
            if (!value.length) {
                this.clear();
            }
        },
    });
};

Bingo.DropdownFilter.setDefaultValues = (sendRequest = true) => {
    $('select.js__filter-select').each(function () {
        const defaultFilterValue = $(this).data('filter-default-value');
        if (defaultFilterValue) {
            if (!sendRequest) {
                $(this).data('filter-send-request', 'false');
            }

            $(this)[0].selectize.setValue(defaultFilterValue);

            if (!sendRequest) {
                $(this).data('filter-send-request', 'true');
            }
        }
    });
};
